import { Alert, AlertTitle, Box, Button, CircularProgress, Container, FormControl, TextField, Typography } from "@mui/material";
import { FC, useState } from "react";
import { forgotPassword, ForgotPasswordPayload } from "src/apis/auth";

const ForgotPassword: FC = () => {
  const [email, setEmail] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setLoading(true);

    const payload: ForgotPasswordPayload = {
      email: email,
    }

    try {
      await forgotPassword(payload)

      setSuccess(true);
    } catch(err: any) {
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
        textAlign: "center",
        // backgroundColor: "#ffe7db",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "90%",
          maxWidth: "400px",
          borderRadius: "16px",
          padding: "40px",
          paddingBottom: "30px",
          gap: "3rem",
        }}
      >
        <Typography fontSize={40} fontFamily="monospace" fontWeight={600}>
          Eezycare
        </Typography>

        {!success && (
          <Typography>
            Preencha o formulário abaixo para recuperar seu acesso
          </Typography>
        )}

        <FormControl
          component="form"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
          onSubmit={handleSubmit}
        >
          {success ? (
            <Alert severity="success" icon={<></>}>
              <AlertTitle>
                Enviamos um e-mail para <strong>{email}</strong> com as instruções de recuperação de acesso, por favor continue o processo a partir dele
              </AlertTitle>
            </Alert>
          ) : (
            <Box>
              <TextField
                id="email"
                label="Email"
                fullWidth
                type={"email"}
                onChange={(e) => {
                  setEmail(e.target.value)
                }}
                required
                InputLabelProps={{ required: false }}
                helperText="O e-mail utilizado para acessar o sistema Eezycare One"
                disabled={success}
              />

              <Button
                variant="contained"
                type="submit"
                disabled={loading}
                sx={{
                  width: "100%",
                  height: '56px'
                }}
              >
                {loading ? (
                  <Box sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}>
                    <CircularProgress
                      size="1.25rem"
                      sx={{
                        marginRight: 1
                      }}
                    /> Enviando...
                  </Box>
                ) : (
                  <Box>Enviar</Box>
                )}
              </Button>
            </Box>
          )}
        </FormControl>
      </Box>
    </Container>
  );
}

export default ForgotPassword;
